import React, { useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import './App.css';
import { useTenant } from './context/TenantContext';
import HomePage from './unAuth/HomePage';
import Login from './login';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import PricingPage from './unAuth/PricingPage';
import SignUp from './unAuth/SignUp';
import Contact from './unAuth/Contact';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RefPolicy from './pages/RefundPolicy';
import UserAccountPage from './pages/UserAccountPage';
import SignUpTest from './unAuth/PhoneSignUptest';
import RouteChangeLoader from './utils/RouteChangeLoader';
import AccountBilling from './pages/AccountBilling';
import CheckoutPage from './components/CheckoutPage';


function App() {

  return (
    <>
      <RouteChangeLoader />
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/pricingpage" element={<PricingPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refunds" element={<RefPolicy />} />
          <Route path="/account" element={<UserAccountPage />} />
          <Route path="/accountbilling" element={<AccountBilling />} />
          <Route path="/checkout" element={<CheckoutPage />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<PrivateRoute />}>
            <Route index element={<Dashboard />} />
          </Route>
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </>
  );
}

export default App;